import 'reflect-metadata';
import {IsNumber, IsString} from 'class-validator';
import {Expose} from 'class-transformer';

export class Bids {
  static Endpoints = {
    BaseRoute: 'bidRfp'
  }
  static Actions = {
    AwardRfp: 'awardRfp',
    CreateBid: 'vendorResponse',
    DeleteBid: 'vendorResponse',
    AddVendor: 'addVendor',
    DeleteBidAssignment: 'removeVendor',
    UpdateBidAssignment: 'updateVendor',
    EditBidList: 'updateBidList',
    ReplaceGC: 'replaceGC',
    BidPackage: 'bidPackage'
  }
  public static BidModuleName = 'Bids';
  public static SolicitationModuleName = 'Solicitations';
  public static Permissions = {
    ListSolicitation: 'Solicitations:List',
    CreateSolicitation: 'Solicitations:Create',
    UpdateSolicitation: 'Solicitations:Update',
    DeleteSolicitation: 'Solicitations:Delete',
    ReadSolicitation: 'Solicitations:Read',
    ListBid: 'Bids:List',
    CreateBid: 'Bids:Create',
    UpdateBid: 'Bids:Update',
    DeleteBid: 'Bids:Delete',
    ReadBid: 'Bids:Read'
  }
}

export class BidListApi {
  static CreateAction = 'vendorResponse';
}

export class CreateBidListParams {
  @Expose()
  get bidAmount(): number {
    return parseFloat((this._bidAmount + '').replace(/[^0-9.]/g, ''));
  }

  set bidAmount(value: number) {
    this._bidAmount = value;
  }
  @IsNumber()
  @Expose()
  bidRfpId: number = 0;

  @IsString()
  @Expose()
  dirRegNo: string = '';

  @Expose() private _bidAmount: number = 0;

  @Expose()
  classificationIds: number[] = [];
}